import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import "./plugins/errorListener";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import veProgress from "vue-ellipse-progress";
import SimpleTypeahead from "vue3-simple-typeahead";

import "@/assets/scss/app.scss";

const pinia = createPinia();

const app = createApp(App)
  .use(router)
  .use(store)
  .use(veProgress)
  .use(SimpleTypeahead)
  .use(pinia);

app.mount("#app");
